import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * request模块
 * @param  {string} url  请求url
 * @param  {object} opts  参数
 * @memberof module:request
 * @example
 * request(url, {
  *     params: {course_id:123},
  *     method: 'POST'
  * };
  *
  * @reurn {promise}
  */
import { uuid, uint32 } from './util_29_uuid';
import { isClient } from './util_00_env';
import { login } from './util_08_login';
import { getUin, getBkn, isFudaoApp, isFudaoClient, getAppVersion, getPlatForm } from './util_04_ua';
import { retcode } from './util_20_retcode';
import { monitor } from './util_19_monitor';
import { objectToQueryString } from './util_09_url';
import { wnsCgi } from './util_28_wnscgi';
import { isObject } from './util_10_lang';
var CGI_HTTP_TIMEOUT = 'cgi_http_timeout';
var CGI_HTTP_STATUS_ERROR = 'cgi_http_status_error';
var CGI_PARAMS_ERROR = 'cgi_params_error';
var CGI_SERVER_ERROR = 'cgi_server_error';
var CGI_SERVER_TIMEOUT = 'cgi_server_timeout';
var CGI_OTHER_ERROR = 'cgi_other_error';
var CGI_SUCC = 'cgi_succ';
var WNS_NATIVE_ERROR = 'wns_native_error';
var WNS_SERVER_ERROR = 'wns_server_error';
var WNS_TIMEOUT = 'wns_timeout';
var WNS_HTTP_STATUS_ERROR = 'wns_http_status_error';
var WNS_SUCC = 'wns_succ';
var WNS_ERROR = 'wns_error';
var WNS_OTHER_ERROR = 'wns_other_error';
var OTHER_ERROR_CODE = 998;
var onEduWebSkeyUpdatedCbs = [];
var mids = {};
var lazyReport = false;
var isNativeSupportWns = isFudaoApp() && (getPlatForm() === 'ios' && getAppVersion() >= 45 || getPlatForm() === 'android' && getAppVersion() >= 88);

if (isClient) {
  window.messageListeners = window.messageListeners || {};

  window.OnEduWebSkeyUpdated = function () {
    var callback;

    while (callback = onEduWebSkeyUpdatedCbs.pop()) {
      callback();
    }
  };
}

function reportKeyCgi(url, code) {
  console.info('reportKeyCgi', url); // 关键CGI埋点

  if (window.keyCgi && url.indexOf(window.keyCgi) >= 0 && code === 0) {
    if (window.T && !window.T.cgiEnd) {
      window.T.cgiEnd = Date.now();
    }
  }
}

function monitorReport(_ref) {
  var url = _ref.url,
      code = _ref.code,
      delay = _ref.delay,
      options = _ref.options,
      _ref$result = _ref.result,
      result = _ref$result === void 0 ? {} : _ref$result,
      _ref$isWns = _ref.isWns,
      isWns = _ref$isWns === void 0 ? false : _ref$isWns,
      requestId = _ref.requestId;
  console.info('monitorReport', url, code, delay, options, requestId); // 100000的时候不监控
  // -100表示wns通道关闭

  if (code === 100000) {
    return;
  } // cgi返回码上报和测速上报


  var monitorReportUrl = url.replace(/^(\/*)fudao\.qq\.com/, '');
  var monitorReportUin = getUin();
  retcode.report(monitorReportUrl, code, delay, monitorReportUin, {}); // 上报monitor

  if (isWns) {
    reportBadJsAndMonitorWns(url, code, options, result);
  } else {
    // 返回码非0，上报badjs
    reportBadJs(url, code, options, requestId);
    monitorCgi(code);
  }
}

function reportBadJs(url, code, options, requestId) {
  if (code !== 0) {
    window.BJ_REPORT && window.BJ_REPORT.info("Ajax ERR: [url: ".concat(url, "] [retcode: ") + "".concat(code, "] [params: ").concat(JSON.stringify(options), "] [requestId: ").concat(requestId, "]"));
  }
}

function monitorCgi(code) {
  // 上报monitor
  if ([500, 501, 502, 503, 504, 505, 506, 403, 404, 401, 400].indexOf(code) !== -1) {
    monitor.report(mids[CGI_HTTP_STATUS_ERROR], CGI_HTTP_STATUS_ERROR, null, true);
  } else {
    var mapCodeToType = {
      100001: CGI_PARAMS_ERROR,
      100003: CGI_SERVER_ERROR,
      100012: CGI_SERVER_TIMEOUT,
      0: CGI_SUCC,
      999: CGI_HTTP_TIMEOUT
    };
    var ty = mapCodeToType[code] || CGI_OTHER_ERROR;
    monitor.report(mids[ty], ty, null, true);
  }
}

function reportBadJsAndMonitor(msg, mid) {
  console.log('reportBadJsAndMonitor', msg, mid);
  window.BJ_REPORT && window.BJ_REPORT.info({
    msg: msg,
    ext: {
      msid: mid
    }
  });
}

function reportBadJsAndMonitorWns(url, code, options, result) {
  // wns success
  if (code === 0) {
    reportBadJsAndMonitor("Wns SUCC: [url: ".concat(url, "] [retcode: ") + "".concat(code, "] [params: ").concat(JSON.stringify(options), "] [monitor_name: ").concat(WNS_SUCC, "]"), mids[WNS_SUCC]);
    return;
  } // 上报monitor


  if ([500, 501, 502, 503, 504, 505, 506, 403, 404, 401, 400].indexOf(code) !== -1) {
    reportBadJsAndMonitor("Wns ERR: [url: ".concat(url, "] [retcode: ") + "".concat(code, "] [params: ").concat(JSON.stringify(options), "] [result: ").concat(JSON.stringify(result), "] [monitor_name: ").concat(WNS_HTTP_STATUS_ERROR, "]"), mids[WNS_HTTP_STATUS_ERROR]);
  } else {
    var mapCodeToType = {
      100001: WNS_SERVER_ERROR,
      100003: WNS_SERVER_ERROR,
      100012: WNS_SERVER_ERROR,
      100400: WNS_SERVER_ERROR,
      // 参数错误
      100500: WNS_SERVER_ERROR,
      // 内部服务器错误
      100503: WNS_SERVER_ERROR,
      // 服务器目前无法使用
      '-101': WNS_NATIVE_ERROR,
      // 参数错误
      100: WNS_NATIVE_ERROR,
      // ios协议错误
      101: WNS_NATIVE_ERROR,
      // ios回包错误
      '-1': WNS_NATIVE_ERROR,
      // android参数或回包错误
      999: WNS_TIMEOUT,
      // 超时
      0: WNS_SUCC // WNS成功

    };
    var ty = mapCodeToType[String(code)] || WNS_OTHER_ERROR; // wns_other_error

    reportBadJsAndMonitor("Wns ERR: [url: ".concat(url, "] [retcode: ") + "".concat(code, "] [params: ").concat(JSON.stringify(options), "] [result: ").concat(JSON.stringify(result), "] [monitor_name: ").concat(ty, "]"), mids[ty]); // WNS失败  不为0的时候都要上报一下

    if (code !== 0) {
      reportBadJsAndMonitor("Wns ERR: [monitor_name: ".concat(WNS_ERROR, "]"), mids[WNS_ERROR]);
    }
  }
}

function wnsFetch(url, opt) {
  if (!/^http/.test(url)) {
    url = "".concat(window.location.protocol, "//fudao.qq.com").concat(url);
  }

  return new Promise(function (resolve, reject) {
    opt.success = function (res) {
      res.json = function () {
        return new Promise(function (resolve) {
          var body = JSON.parse(res.body);
          resolve(body);
        });
      };

      res.headers.get = function (headerKey) {
        return res.headers[headerKey];
      };

      resolve(res);
    };

    opt.error = function (res) {
      // 超时或者通道错误的时候返回
      res.retcode = res.errCode; // 转换一下errCode

      reject(res);
    };

    wnsCgi(url, opt);
  });
}

function onResponsed(response) {
  var status = response.status; // [0, 500, 501, 502, 503, 504, 505, 506, 403, 404, 401, 400]

  var xServer = response.headers.get('x-server'); // 获取xserver头, fetch与wnsFetch返回值均有该方法

  if (status >= 400 && status < 506 || !status) {
    if (window.BJ_REPORT) {
      window.BJ_REPORT.info("fetch response status error: ".concat(status));
    }

    return Promise.reject({
      retcode: response.status || 998,
      xServer: xServer
    });
  }

  return response.json().then(function (json) {
    json.dev_mode = response.headers.get('DevMode') === 'exp';
    json.xServer = xServer;
    json.headers = response.headers;
    return json;
  });
}

function addParamsToUrl(url, queryString) {
  var joinSign = '?';

  if (!queryString) {
    return url;
  }

  if (url.indexOf('?') > -1) {
    joinSign = '&';
  }

  return "".concat(url).concat(joinSign).concat(queryString);
} // 创建 fetch url


function createFetchUrl(url, params) {
  var queryString = objectToQueryString(params);
  var urlWithParams = addParamsToUrl(url, queryString);
  return urlWithParams.replace(window.location.origin, '').replace('?', '___');
} // 解析 fetch url


function parseFetchUrl(fetchUrl) {
  var splitUrl = fetchUrl.split('___');
  var cgi = splitUrl[0] || '';
  var paramsStr = splitUrl[1] || '';
  var params = {};
  paramsStr.split('&').forEach(function (part) {
    var splitPart = part.split('=');
    params[splitPart[0]] = splitPart[1] || '';
  });
  return {
    cgi: cgi.replace(window.location.origin, ''),
    params: params
  };
} // 创建监听列表


function createListeners(url, params, options) {
  var success = options.success,
      error = options.error;
  var fetchUrl = createFetchUrl(url, params);
  messageListeners[fetchUrl] = messageListeners[fetchUrl] || {
    options: options,
    successList: [],
    errorList: []
  };
  var listener = messageListeners[fetchUrl];

  if (success) {
    listener.successList.push(success);
  }

  if (error) {
    listener.errorList.push(error);
  }
}

function createCacheUrl(url, params, options) {
  var _options$method = options.method,
      method = _options$method === void 0 ? '' : _options$method;
  url = addParamsToUrl(url, objectToQueryString({
    _cache: 1,
    _uin: getUin()
  }));

  if (method.toUpperCase() === 'POST') {
    var formDataObj = {
      _formData: objectToQueryString(params)
    };
    url = addParamsToUrl(url, objectToQueryString(formDataObj));
  }

  return url;
}

if (isClient && navigator.serviceWorker && !window.hasListenerSwMessage) {
  window.hasListenerSwMessage = true;
  navigator.serviceWorker.addEventListener('message', function (event) {
    try {
      var messageResult = JSON.parse(event.data);
      var _messageResult$fetchU = messageResult.fetchUrl,
          fetchUrl = _messageResult$fetchU === void 0 ? '' : _messageResult$fetchU,
          data = messageResult.data,
          _retcode = messageResult.data.retcode,
          cost = messageResult.cost;

      var _parseFetchUrl = parseFetchUrl(fetchUrl),
          cgi = _parseFetchUrl.cgi,
          params = _parseFetchUrl.params;

      fetchUrl = fetchUrl.replace(window.location.origin, '').replace('&preload=1', '');
      var listenerObj = messageListeners[fetchUrl];

      if (listenerObj) {
        console.log('in listen list');
        console.log('fetchUrl', fetchUrl);
        var callbackName = _retcode === 0 ? 'successList' : 'errorList';
        var callbackList = listenerObj[callbackName];
        var callback;

        if (_retcode === 100000) {
          if (listenerObj.options.needLogin !== false) {
            // 不在APP内，则拉起ptlogin登录
            login(window.location.href);
          } else {
            data = {
              _retcode: 100000,
              msg: 'But there is no login state'
            };
          }
        }

        while (callback = callbackList.pop()) {
          callback(data, {
            source: 'cgi'
          });
        }

        if (callbackList.length === 0) {
          delete messageListeners[fetchUrl];
        } // 返回码上报
        // serviceWorker返回


        monitorReport({
          url: cgi,
          code: data ? _retcode : 998,
          delay: cost,
          options: params
        });
        reportKeyCgi(cgi, data ? _retcode : 998);
      }
    } catch (e) {
      window.BJ_REPORT && window.BJ_REPORT.info("sw to request ERR: ".concat(e));
    }
  });
}

function req(url, options, useWns) {
  var method = (options.method || options.type || 'GET').toUpperCase();
  var data = options.data || options.params || options.body || {};
  var multipart = options.multipart || false; // 文件上传 multipart/form-data
  // 增加非GET、非HEAD方法的参数的JSON支持

  var useJSON = options.useJSON || false;
  data.bkn = options.useBkn !== false && getBkn();

  if (method === 'GET') {
    data.t = Math.random();
  }

  var cgi = url;
  var params = useJSON || multipart ? data : objectToQueryString(data);
  var headerContentType = useJSON ? 'application/json; charset=UTF-8' : 'application/x-www-form-urlencoded; charset=UTF-8';
  var headers = multipart ? options.headers : Object.assign({
    'Content-Type': headerContentType
  }, options.headers);
  var opt = Object.assign({
    credentials: 'same-origin',
    timeout: 10000
  }, options, {
    method: method,
    headers: headers
  });
  var _options$headers = options.headers;
  _options$headers = _options$headers === void 0 ? {} : _options$headers;
  var _options$headers$XRe = _options$headers['X-Request-Id'],
      requestId = _options$headers$XRe === void 0 ? '' : _options$headers$XRe;

  if (method === 'GET' || method === 'HEAD') {
    url += (url.indexOf('?') === -1 ? '?' : '&') + params;
  } else {
    opt.body = useJSON ? JSON.stringify(params) : params;
  } // 超时设置


  function timeout(ms, promise) {
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        reject({
          retcode: 999,
          type: 'timeout',
          msg: '请求超时',
          url: url,
          xServer: 'request timeout' // 请求超时情况下，无法获取到reponse的x-server头

        });
      }, ms);
      promise.then(function (resData) {
        resolve(resData);
      }, reject);
    });
  }

  var startTime = Date.now();

  if (useWns) {
    console.info('req useWns', url);

    var _wnsCgi = cgi.replace('/cgi-bin/', '/wns/cgi-bin/').replace('/cgi-proxy/', '/wns/cgi-proxy/');

    return timeout(opt.timeout, wnsFetch(url, opt)).then(onResponsed)["catch"](function (error) {
      error = error || {};
      console.error('wnsfetch catch error', error); // 统计wns异常
      // badjs/monitor/retcode

      var _error = error,
          _error$retcode = _error.retcode,
          retcode = _error$retcode === void 0 ? OTHER_ERROR_CODE : _error$retcode,
          xServer = _error.xServer;
      var dataWithXServer = Object.assign({}, data, {
        xServer: xServer
      }); // 超时999不上传retcode

      if (retcode !== 999) {
        var cost = Date.now() - startTime; // wns retcode失败上报 专门统计wns

        monitorReport({
          url: _wnsCgi,
          code: retcode,
          delay: cost,
          options: dataWithXServer,
          result: error,
          isWns: true
        });
      } else {
        reportBadJsAndMonitorWns(_wnsCgi, retcode, dataWithXServer, error);
      }

      return Promise.reject(error);
    }).then(function (json) {
      console.info('wnsfetch resolve'); // 统计wns成功
      // badjs/monitor/retcode， monitorReport需要拆分
      // 替换一下url，用来统计wns请求耗时

      var cost = Date.now() - startTime;
      var dataWithXServer = Object.assign({}, data, {
        // 不污染原data数据
        xServer: json.xServer
      }); // wns retcode成功上报， 专门统计wns

      monitorReport({
        url: _wnsCgi,
        code: json ? json.retcode : OTHER_ERROR_CODE,
        delay: cost,
        options: dataWithXServer,
        result: json,
        isWns: true
      });
      return json;
    });
  }

  console.info('req http', url); // 第一次 没有preload
  // 第二次 有preload之后，不支持wns
  // 第三次 可能 refreshskey之后

  return timeout(opt.timeout, fetch(url, opt)).then(onResponsed)["catch"](function (error) {
    if (window.BJ_REPORT) {
      window.BJ_REPORT.info("fetch catch error: [".concat(requestId, "] ").concat(JSON.stringify(error)));
    }

    error = error || {};
    console.error('fetch catch error', error); // fetch失败
    // monitor/retcode/badjs

    var _error2 = error,
        _error2$retcode = _error2.retcode,
        retcode = _error2$retcode === void 0 ? OTHER_ERROR_CODE : _error2$retcode,
        xServer = _error2.xServer;
    var dataWithXServer = Object.assign({}, data, {
      // 不污染原对象
      xServer: xServer
    }); // 超时999不上传retcode

    if (retcode !== 999) {
      var cost = Date.now() - startTime; // fetch retcode错误上报

      monitorReport({
        url: cgi,
        code: retcode,
        delay: cost,
        options: dataWithXServer,
        requestId: requestId
      });
    } else {
      reportBadJs(cgi, retcode, dataWithXServer);
      monitorCgi(retcode);
    }

    return Promise.reject(error);
  }).then(function (json) {
    console.info('fetch resolve'); // fetch成功
    // monitor/retcode/badjs
    // 如果是非serviceworker返回的才会上报

    if (!opt.useCache) {
      var cost = Date.now() - startTime;
      var dataWithXServer = Object.assign({}, data, {
        xServer: json.xServer
      });

      if (!json) {
        if (window.BJ_REPORT) {
          window.BJ_REPORT.info("fetch no data [".concat(requestId, "]"));
        }
      } // fetch retcode成功上报


      monitorReport({
        url: cgi,
        code: json ? json.retcode : OTHER_ERROR_CODE,
        delay: cost,
        options: dataWithXServer,
        requestId: requestId
      });
    }

    return json;
  });
}
/**
 * request模块
 * @param  {string} url  请求url
 * @param  {object} opts  参数
 * @memberof module:request
 * @example
 * request(url, {
  *     params: {course_id:123},
  *     method: 'POST'
  * };
  *
  * @reurn {promise}
  */


function request() {
  for (var _len = arguments.length, argument = new Array(_len), _key = 0; _key < _len; _key++) {
    argument[_key] = arguments[_key];
  }

  // 提取请求参数
  var args = [].slice.call(argument);
  var startWithUrl = typeof args[0] === 'string';
  var options = startWithUrl ? args[1] || {} : args[0] || {};
  var _options$params = options.params,
      params = _options$params === void 0 ? {} : _options$params;
  var requestId = uuid();
  var spanId = uint32();
  var shortRequestId = requestId.split('-')[0];
  var url = startWithUrl ? args[0] : options.url;
  options.headers = _objectSpread({
    'X-Request-Id': requestId,
    'X-Span-Id': spanId
  }, options.headers);

  if (options.requestId === false) {
    delete options.headers['X-Request-Id'];
  }

  if (options.useCache) {
    url = createCacheUrl(url, params, options);
    createListeners(url, params, options);
  } // const testWnsFlag = localStorage.getItem('requestType') === 'wns';
  // console.log('request: requestType=' + localStorage.getItem('requestType'), 'testWnsFlag=', testWnsFlag);
  // 需要登陆的逻辑


  function retryAfterLogin(resolve, reject) {
    req(url, options).then(function (json) {
      if (json && Number(json.retcode) === 0) {
        // eslint-disable-next-line
        window.BJ_REPORT && window.BJ_REPORT.info("refresh succ: [url: ".concat(url, "] [retcode: ").concat(json.retcode, "] [params: ").concat(JSON.stringify(options.params), "]"));

        if (options.success) {
          options.success(json);
        }

        resolve(json);
      } else {
        if (options.error) {
          options.error(json);
        }

        reject(json);
      }
    });
  }

  function goLogin(json) {
    console.info('goLogin', options);

    if (isFudaoApp()) {
      return new Promise(function (resolve, reject) {
        window.mqq.invoke('edu', 'refreshSkey', {}, function () {
          retryAfterLogin(resolve, reject);
        });
      });
    }

    if (isFudaoClient()) {
      return new Promise(function (resolve, reject) {
        var startTime = Date.now();
        onEduWebSkeyUpdatedCbs.push(function () {
          var costTime = Date.now() - startTime;
          window.BJ_REPORT && window.BJ_REPORT.info("request call IM.UpdateSkey cost time: ".concat(costTime));
          retryAfterLogin(resolve, reject);
        });

        if (window.external.nativeCall) {
          window.external.nativeCall('CallHummerApi', [JSON.stringify({
            functionName: 'IM.UpdateSkey'
          })], function () {});
        } else if (window.external.CallHummerApi) {
          window.external.CallHummerApi('IM.UpdateSkey');
        }
      });
    }

    return new Promise(function (resolve, reject) {
      console.log('check options', options); // 不在APP内，则拉起ptlogin登录

      if (options.needLogin !== false) {
        // 不在APP内，则拉起ptlogin登录
        login(window.location.href);

        if (options.error) {
          options.error(json);
        }

        reject(json);
      } else {
        // eslint-disable-next-line
        if (options.error) {
          options.error(json);
        }

        reject({
          retcode: 100000,
          msg: 'But there is no login state'
        });
      }
    });
  } // 预加载cgi逻辑
  // todo preload json.parse错误的捕捉


  if (!!window.Preload && options.preload) {
    // && !options.preloadFail
    return new Promise(function (resolve, reject) {
      window.Preload.get({
        url: url,
        data: params
      }, function (data) {
        // 重复取会返回null
        console.log('request get data from preload, data=', data, url);

        if (!data) {
          options.preload = false;
          resolve(request.apply(void 0, _toConsumableArray(args))); // 返回错误，重新拉取数据

          return;
        }

        var _data$retcode = data.retcode,
            retcode = _data$retcode === void 0 ? 998 : _data$retcode,
            delay = data.delay,
            _requestId = data.requestId,
            xServer = data.xServer;
        console.log('here', xServer);

        if (xServer) {
          params.xServer = xServer;
        }

        if (retcode === 999) {
          // 超时不上报retcode
          monitorCgi(retcode);
          reportBadJs(url, retcode, params, _requestId);
        } else {
          // 非超时
          monitorReport({
            url: url,
            code: retcode,
            delay: delay,
            options: params,
            _requestId: _requestId
          });
        } // 如果错误码是998或者999，重试


        if (retcode === 998 || retcode === 999) {
          // 上报预加载失败
          options.preload = false;
          options.usePreload = true;
          return resolve(request.apply(void 0, _toConsumableArray(args))); // 返回错误，重新拉取数据
        } // 后台系统错误码范围：139200 到 139299 之间，错误码在这之间会认为请求失败，否则会认为是业务错误码，交给业务处理


        if (retcode === 0 || retcode < 139200 || retcode > 139299) {
          if (options.success) {
            options.success(data);
          }

          reportKeyCgi(url, retcode);
          return resolve(data);
        } // 用户未登录处理逻辑


        if (retcode === 100000) {
          console.info('preload login');
          return resolve(goLogin(data));
        }

        if (options.error) {
          options.error(data);
        }

        reject(data);
      });
    });
  } // options.preloadFail = false;
  // formdata的情况不用wns


  var isNotFormData = !(options.headers && /multipart\/form-data/i.test(options.headers['Content-Type']));
  var wnsAble = isNotFormData && !options.noWns; // 符合过滤规则的可以使用wns
  // 如果preload失败，尝试一次wns
  // 正式：

  var useWns = !!options.usePreload && wnsAble && isNativeSupportWns; // 测试  delete
  // const useWns = ( testWnsFlag && wnsAble  //wns测试
  //   || (!testWnsFlag && !!options.usePreload && wnsAble && isNativeSupportWns)); //正常逻辑

  console.log('useWns = ', useWns, 'usePreload', !!options.usePreload, 'wnsAble', wnsAble, 'isNativeSupportWns', isNativeSupportWns);
  return req(url, options, useWns)["catch"](function (error) {
    error = error || {};
    error.url = url;
    error.shortRequestId = shortRequestId;
    error.requestId = requestId;
    console.error('req catch', error); // 如果之前还没有用wns， 重新用wns试一次
    // 并且错误码是999|998

    var _error3 = error,
        retcode = _error3.retcode;

    if (!useWns && wnsAble && isNativeSupportWns && (error instanceof SyntaxError || retcode === 998 || retcode === 999)) {
      return req(url, options, true)["catch"](function (error) {
        error = error || {};
        error.url = url; // catch

        console.error('req second wns catch', error);

        if (options.error) {
          options.error(error);
        }

        return Promise.reject(error);
      });
    }

    if (options.error) {
      options.error(error);
    } // console.error('req catch error', error);


    return Promise.reject(error);
  }).then(function (json) {
    var success = options.success,
        error = options.error,
        useCache = options.useCache,
        needLogin = options.needLogin;
    console.info('request success json=', json);

    if (isObject(json)) {
      json.shortRequestId = shortRequestId;
      json.requestId = requestId;
    }

    if (json && json.retcode === 0) {
      // 返回正确成功
      if (success) {
        var copyParams = _objectSpread({}, params);

        delete copyParams.bkn;
        delete copyParams.t; // 如果是 serviceWorker 异步拉取接口先返回结果，那么就不再使用 serviceWorker 的缓存

        if (useCache && !messageListeners[createFetchUrl(url, copyParams)]) {
          return;
        }

        success(json);
      }

      if (!useCache) {
        reportKeyCgi(url, json ? json.retcode : 998);
      }

      return Promise.resolve(json); // 成功并且retcode为0
    } // 用户未登录处理逻辑


    if (json && Number(json.retcode) === 100000 && needLogin !== false) {
      return goLogin(json);
    }

    if (error) {
      error(json);
    }

    return Promise.reject(json);
  });
}

request.init = function (opts) {
  mids = opts.mids;
  lazyReport = opts.lazyReport;
}; // eslint-disable-next-line


export { request };